import raw from '@shared/catalog/effects.json';
import brandRaw from '@shared/brand.json';
import type { Catalog } from './chain';

export const catalog = raw as unknown as Catalog;

export interface Brand {
  name: string;
  shortName: string;
  tagline: string;
  supportEmail: string;
  websiteUrl: string;
}
export const brand = brandRaw as Brand;
